import React from "react";
import styles from "./PriceList.module.scss";
import { withStyles } from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";
import Arrow from "../../../../assets/img/arrow_r_small.png";
import Fade from "@material-ui/core/Fade";
import LawyerCard from "../../../Shared/LawyerCard/LawyerCard";

const StyledRating = withStyles({
  iconFilled: {
    color: "#8ec04b",
  },
  iconHover: {
    color: "#8ec04b",
  },
})(Rating);

class PriceList extends React.Component<any, any> {
  constructor(props) {
    super(props);
  }

  render() {
    const { lawyer, opinions, services, toggleSchedules } = this.props;

    let opinionText = "opinii";
    if (opinions) {
      if (opinions.totalOpinionVerified === 1) opinionText = "opinia";
      else if (opinions.totalOpinionVerified < 5) opinionText = "opinie";
    }

    return (
      <Fade in={true} timeout={800}>
        <div className={styles.PriceList}>
          <div className={styles.lawyerCard}>
            <LawyerCard lawyer={lawyer} imageUrl={this.props.imageUrl} />
          </div>
          <div className={styles.list}>
            {services &&
              services.map((service) => {
                if (service.Domain.id == this.props.domainId) {
                  return (
                    <div key={service.id}>
                      <div className={styles.mainService}>
                        <h3 className={styles.nameAndPrice}>
                          <span className={styles.name}>Wideokonsultacja</span>{" "}
                          -{" "}
                          <span className={styles.price}>
                            {service.price} zł
                          </span>
                        </h3>
                        <div className={styles.desc}>
                          (koszt za 30 minut rozmowy)
                        </div>
                      </div>
                      <hr />
                      <div className={styles.subServices}>
                        {service.SubServices && (
                          <>
                            <h3 className={styles.title}>Usługi</h3>
                            <div className={styles.subtitle}>
                              (orientacyjny koszt uzależniony od nakładu pracy)
                            </div>

                            {/*<ul>*/}
                            {service.SubServices.map((subService) => {
                              return (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: subService.name,
                                  }}
                                />
                                // <li key={subService.id}>
                                //     <span className={styles.text}>{subService.name} - {subService.price}</span>
                                // </li>
                              );
                            })}
                            {/*</ul>*/}
                          </>
                        )}
                      </div>
                    </div>
                  );
                }
              })}
          </div>

          <div className={styles.opinionInfo}>
            <div className={styles.left}>
              <StyledRating
                name="star-rating"
                value={opinions.average}
                precision={0.5}
                className={styles.stars}
                readOnly
                size="small"
              />
              <div className={styles.text}>Ogólna ocena</div>
            </div>

            <span className={styles.count} onClick={this.props.toggleOpinions}>
              {opinions ? opinions.opinions.totalOpinionVerified : 0}{" "}
              {opinionText} <img src={Arrow} alt="Arrow" />
            </span>
          </div>

          {/*<div className={styles.fixedContainer}>*/}
          {/*    <Button*/}
          {/*        variant="contained"*/}
          {/*        color="primary"*/}
          {/*        className={styles.order}*/}
          {/*        onClick={toggleSchedules}*/}
          {/*    >*/}
          {/*        <CalendarIcon2/> Umów się na wizytę*/}
          {/*    </Button>*/}
          {/*</div>*/}
        </div>
      </Fade>
    );
  }
}

PriceList.defaultProps = {};

export default PriceList;
